import {Field} from 'formik';
import {Stack} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {FormikRadioGroup} from '@flexinet/ui-components';
import {useChannelOptions} from '../../../billing-providers/hooks/useChannelOptions.ts';

// FNP-607: the channel is the only filter and is REQUIRED (it is the
// channel-runStartedAt-index partition key). Rendered as a radio group (not a
// select) — a small set of mutually-exclusive options, always exactly one selected.
// FNP-616: the option set is now CATALOG-DRIVEN (the ENABLED BillingProvider keys),
// not a hardcoded STRIPE/AWS_MARKETPLACE/INTERNAL list.
export const FilterFormComponent = () => {
    const {options: channelOptions, loading} = useChannelOptions();

    return (
        <Stack gap='md' my='md'>
            <Field
                name='channel'
                label={I18n.get('Channel')}
                description={loading ? I18n.get('Loading channels…') : I18n.get('Reports are listed per channel; a channel is always selected.')}
                data={channelOptions}
                direction='vertical'
                component={FormikRadioGroup}
            />
        </Stack>
    );
};
